<template>
  <v-autocomplete
    v-model="givenValue"
    :items="roles"
    :label="label"
    :data-test="dataTest"
    v-bind="$attrs"
    outlined
    clearable
    item-value="id"
    item-text="name"
    hide-no-data
    append-icon="$iconSearch"
    v-on="$listeners"
  />
</template>

<script>
import { useRoleHelper } from "@composables/masterdata/person/roles";
export default {
  name: "AppSelectRole",
  props: {
    value: {
      type: [String, Array, Object],
      default: null
    },
    possibleValues: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Role"
    },
    haveScopes: {
      type: Array,
      default: () => []
    },
    haveEntities: {
      type: Array,
      default: () => []
    },
    excludeEntities: {
      type: Array,
      default: () => []
    },
    disciplineCodenames: {
      type: Array,
      default: () => []
    },
    noSystem: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: true
    },
    dataTest: {
      type: String,
      default: "roles"
    }
  },
  setup() {
    return {
      ...useRoleHelper()
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    roles() {
      if (this.possibleValues.length > 0) {
        return this.masterRolesAll.filter(x =>
          this.possibleValues.includes(x.id)
        );
      }
      let roles = this.getRolesFromMaster({
        noSystem: this.noSystem,
        active: this.active
      });

      if (this.disciplineCodenames.length) {
        roles = roles.filter(
          role =>
            (role.canBeGrantedInDisciplineCodenames?.length ?? 0) == 0 ||
            role.canBeGrantedInDisciplineCodenames.some(x =>
              this.disciplineCodenames.includes(x)
            )
        );
      }

      if (this.haveScopes.length) {
        roles = roles.filter(role =>
          role.allowedScopes.some(x => this.haveScopes.includes(x))
        );
      }

      if (this.haveEntities.length) {
        roles = roles.filter(role =>
          role.requiresRelationsToEntities.some(x =>
            this.haveEntities.includes(x)
          )
        );
      }

      if (this.excludeEntities.length) {
        roles = roles.filter(
          role =>
            !role.requiresRelationsToEntities.some(x =>
              this.excludeEntities.includes(x)
            )
        );
      }
      return roles;
    }
  }
};
</script>
